const contactAnim = {
  init() {
    document.addEventListener("DOMContentLoaded", () => {
      /* GSAP ANIMATIONS */

      //Smooth content

      ScrollSmoother.create({
        wrapper: "#smooth-container",
        content: "#smooth-content",
        smooth: 1,
        effects: true,
      });

      window.addEventListener("load", () => ScrollTrigger.refresh(), {
        once: true,
      });

      const protectedEmail = document.querySelector(".contact-email");
      if (protectedEmail) {
        protectedEmail.addEventListener("click", (event) => {
          event.preventDefault();

          const email = window.atob(protectedEmail.dataset.email);
          protectedEmail.href = `mailto:${email}`;
          protectedEmail.textContent = email;
          protectedEmail.removeAttribute("data-email");
          protectedEmail.click();
        }, { once: true });
      }

      const animatedTitles = document.querySelectorAll(
        ".contact-header h1, .contact-form-header h2",
      );
      if (animatedTitles.length && typeof gsap !== "undefined") {
        animatedTitles.forEach((title) => {
          const words = title.textContent.trim().split(/\s+/);

          if (words.length) {
            title.textContent = "";

            words.forEach((word) => {
              const wordWrap = document.createElement("span");
              wordWrap.className = "presentation-title__word";
              wordWrap.textContent = word;
              title.appendChild(wordWrap);
              title.appendChild(document.createTextNode(" "));
            });

            const titleWords = title.querySelectorAll(
              ".presentation-title__word",
            );
            gsap.set(titleWords, { opacity: 0, lineHeight: 1.25 });

            gsap.to(titleWords, {
              opacity: 1,
              duration: 2,
              ease: "sine.out",
              stagger: 0.1,
              scrollTrigger: {
                trigger: title,
                start: "top 80%",
                once: true,
              },
            });
          }
        });
      }

      // SCROLL TO TOP BUTTON
      /* const scrollToTopBtn = document.getElementById("scroll-to-top");
      if (scrollToTopBtn) {
        window.addEventListener("scroll", () => {
          if (window.scrollY > 300) {
            scrollToTopBtn.classList.add("visible");
          } else {
            scrollToTopBtn.classList.remove("visible");
          }
        });

        scrollToTopBtn.addEventListener("click", () => {
          ScrollSmoother.get().scrollTo(0, true);
        });
      } */

      // LIENS ANCRES

      // après avoir initialisé ScrollSmoother
      /* if (window.location.hash) {
        const id = window.location.hash.slice(1);
        const target = document.getElementById(id);
        if (target) {
          const smoother = ScrollSmoother.get();
          if (smoother) {
            smoother.scrollTo(target, true, "top top");
          } else {
            target.scrollIntoView({ behavior: "smooth", block: "start" });
          }
        }
      }

      let heroBtn = document.querySelector(".hero-btn");
      heroBtn.addEventListener("click", (e) => {
        e.preventDefault();
        let target = document.querySelector(heroBtn.getAttribute("href"));
        ScrollSmoother.get().scrollTo(target, true, "center center");
      });

      // Sélectionne tous les liens dans le menu et le footer
      const checkSmoother = setInterval(() => {
        if (typeof ScrollSmoother !== "undefined" && ScrollSmoother.get()) {
          clearInterval(checkSmoother);

          // Sélectionne tous les liens dans le menu et le footer
          const menuLinks = document.querySelectorAll(
            '.topmenu-container a[href*="#"], footer a[href*="#"]',
          );
          menuLinks.forEach((link) => {
            link.addEventListener("click", function (e) {
              // only intercept links that point to an anchor on the *current* page
              const href = this.getAttribute("href");
              if (!href) return;

              // build a URL to compare pathnames even when href is relative
              const url = new URL(href, window.location.origin);
              if (url.pathname !== window.location.pathname) {
                // different page, allow normal navigation
                return;
              }

              e.preventDefault();

              // extract the anchor id and scroll to it
              const targetId = url.hash.replace("#", "");
              if (!targetId) return;

              const target = document.getElementById(targetId);
              if (!target) return;

              const smoother = ScrollSmoother.get();
              if (smoother) {
                smoother.scrollTo("#" + targetId, true, "top top");
              } else {
                target.scrollIntoView({ behavior: "smooth", block: "start" });
              }
            });
          });
        }
      }, 100); // Vérifie toutes les 100ms */
    });
  },
};

export default contactAnim;
